import { API } from "../connectBackend";



export const signup = async user => {
    try {
        const response = await fetch(`${API}/signup`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(user)
        });
        return await response.json();
    } catch (err) {
        return console.log(err);
    }
}




export const verifyRegistration = async (verificationTkn) => {
    try {
        const response = await fetch(`${API}/registration/verify/${verificationTkn}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
        });
        return await response.json();
    } catch (err) {
        return console.log(err);
    }
}




export const resendEmailVerification = async (email) => {
    try {
        const response = await fetch(`${API}/account/verify/resend`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email })
        });
        return await response.json();
    } catch (err) {
        return console.log(err);
    }
}




export const signin = user => {
    return fetch(`${API}/signin`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(user)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => console.log(err));
}




export const authenticate = (data, next) => {
    if (typeof window !== "undefined") {
        localStorage.setItem("jwt", JSON.stringify(data))
        next();
    }
}



// export const isAuthenticated = () => {
//     if (typeof window == "undefined") {
//         return false
//     }
//     if (localStorage.getItem("jwt")) {
//         return JSON.parse(localStorage.getItem("jwt"));
//     }
//     else {
//         return false;
//     }
// }





export const isAuthenticated = () => {
    if (typeof window == "undefined") {
        return false;
    }
    if (localStorage.getItem("jwt")) {
        const jwt =  JSON.parse(localStorage.getItem('jwt'));
        const { token } = jwt;
        if (token) {
            const tokenParts = token.split('.');
            if (tokenParts.length === 3) {
                const payload = JSON.parse(decodeURIComponent(window.atob(tokenParts[1])));
                const currentTime = Math.floor(Date.now() / 1000);        //Get current time in seconds

                if (payload.exp && payload.exp < currentTime) {
                    //Token has expired
                    return false;
                } else {
                    //Token is still valid
                    return JSON.parse(localStorage.getItem("jwt"));
                }
            }
        }
    }
    else {
        return false;
    }
}




export const signout = next => {
    if (typeof window !== "undefined") {
        localStorage.removeItem("jwt")
        next();

        return fetch(`${API}/signout`, {
            method: "GET"
        })
            .then(response => {
                // console.log("response: ", response);
                // console.log("Signout successful!");
            })
            .catch(err => console.log(err))
    }
}



export const forgotPassword = (email) => {
    return fetch(`${API}/auth/password/forgot`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email })
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}




export const resetPassword = (resetToken, password, confirmPassword) => {
    return fetch(`${API}/auth/password/reset/${resetToken}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            password,
            confirmPassword
        })
    }).then(response => {
        return response.json();
    }).catch(err => console.log(err))
}


